(() => {
  const cfgMap = () => window.PILTRON_PRICING_PUBLIC || {};
  const group = () => window.PILTRON_PRICE_GROUP === 'EU' ? 'EU' : 'NON_EU';
  const ratioFor = (cfg) => group() === 'EU' ? Number(cfg?.publicRatioEU) : Number(cfg?.publicRatioNonEU);
  const modeFor = (sku) => cfgMap()[sku]?.mode || (String(sku || '').startsWith('PLT-BND-') ? 'bundle' : 'single');
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'ar', {
        style: 'currency', currency: currency || window.Shopify?.currency?.active || 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format((Number(cents) || 0) / 100);
    } catch (_error) {
      return `${Math.ceil((Number(cents) || 0) / 100)} ${currency || 'EUR'}`;
    }
  };
  const publicCents = (variant) => {
    if (!variant) return 0;
    const price = Number(variant.price) || 0;
    const cfg = variant.publicPricing || cfgMap()[variant.sku];
    if (cfg?.catalogIsFrom === true) return Math.round(price);
    const ratio = ratioFor(cfg);
    const raw = ratio > 0 ? price * ratio : price;
    return Math.ceil((raw - 1e-9) / 100) * 100;
  };
  const minPublicCents = (variants) => {
    const values = (variants || []).map(publicCents).filter(v => v > 0);
    return values.length ? Math.min(...values) : 0;
  };
  function updateBlock(block, selectedSku) {
    if (!block) return;
    let variants = [];
    try { variants = JSON.parse(block.querySelector('[data-piltron-starting-variants]')?.textContent || '[]'); } catch (_e) {}
    window.PILTRON_PRICING_PUBLIC ||= {};
    for (const variant of variants) {
      if (variant.sku && variant.publicPricing) window.PILTRON_PRICING_PUBLIC[variant.sku] = variant.publicPricing;
    }
    const sku = selectedSku || block.dataset.selectedSku || '';
    const variant = sku ? variants.find(v => v.sku === sku) : null;
    const chosen = variant || (variants.length === 1 ? variants[0] : null);
    const cents = chosen ? publicCents(chosen) : minPublicCents(variants);
    const effectiveSku = chosen?.sku || sku || variants[0]?.sku || '';
    const mode = modeFor(effectiveSku);
    const label = block.querySelector('[data-piltron-price-label]');
    const value = block.querySelector('[data-piltron-starting-value]');
    const info = block.querySelector('[data-piltron-price-info]');
    const infoText = info?.querySelector('[data-piltron-price-info-text]');
    const locale = (document.documentElement.lang || 'ar').slice(0, 2).toLowerCase();
    const startingLabel = locale === 'de' ? 'Ab ' : (locale === 'en' ? 'From ' : 'يبدأ من ');
    if (label) {
      const isBundle = mode === 'bundle';
      label.hidden = isBundle;
      label.textContent = isBundle ? '' : startingLabel;
      label.dir = locale === 'ar' ? 'rtl' : 'ltr';
    }
      const exactCatalog = (chosen?.publicPricing || cfgMap()[effectiveSku])?.catalogIsFrom === true;
      value.textContent = exactCatalog
        ? new Intl.NumberFormat(document.documentElement.lang || 'ar', {style: 'currency', currency: window.Shopify?.currency?.active || 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2}).format(cents / 100)
        : money(cents);
    block.dataset.pricingMode = mode;
    if (infoText) infoText.textContent = mode === 'bundle'
      ? (locale === 'de'
        ? 'Der angezeigte Preis gilt für das Pflegeset in der aktuell dargestellten Routine-Stufe. Der bestmögliche verfügbare Rabatt wird im Warenkorb automatisch auf alle berechtigten Produkte berechnet – einschließlich des Pflegesets.'
        : locale === 'en'
          ? 'The displayed price is for the care set at the routine level currently shown. The best available discount is calculated automatically in the cart across all eligible products, including the care set.'
          : 'السعر الظاهر هو سعر الباقة لمستوى الروتين المعروض حاليًا. ويُحتسب أفضل تخفيض متاح تلقائيًا في السلة على جميع المنتجات المؤهلة، بما فيها الباقة نفسها.')
      : (locale === 'de' ? 'Der Gesamtbetrag wird anhand der Artikel, Mengen und des Lieferlands berechnet und vor dem Checkout im Warenkorb angezeigt.' : locale === 'en' ? 'The final total is calculated from your items, quantities and delivery country and shown in the cart before checkout.' : 'يتحدد الإجمالي النهائي تلقائيًا حسب محتويات الطلب والكمية ودولة التوصيل، ويظهر بوضوح في السلة قبل المتابعة.');
    if (sku) block.dataset.selectedSku = sku;
  }
  function scan(scope=document) {
    scope.querySelectorAll?.('[data-piltron-starting-price-block]').forEach(block => updateBlock(block));
  }
  async function syncPrivateCartHints() {
    const g = group();
    const restricted = Boolean(window.PILTRON_ORDER_RULES?.restricted);
    const key = `${g}|${restricted}`;
    if (sessionStorage.getItem('piltron_cart_hints') === key) return;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: {
          '__piltron_price_group': g,
          '__piltron_restricted': restricted ? 'true' : 'false'
        }})
      });
      if (response.ok) sessionStorage.setItem('piltron_cart_hints', key);
    } catch (_error) {}
  }
  window.PILTRONPricingUI = { money, publicCents, minPublicCents, modeFor, updateBlock, scan, syncPrivateCartHints };
  const init = () => { scan(document); syncPrivateCartHints(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', e => scan(e.target));
  const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;

      if (node.matches('[data-piltron-starting-price-block]')) {
        updateBlock(node);
      }

      node.querySelectorAll('[data-piltron-starting-price-block]')
        .forEach(block => updateBlock(block));
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
})();
